import {fromJS, Map} from 'immutable';
import rewardsTop10GamesActions from '../../actions/fortnite-game/rewardsTop10Games.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {Datapoint} from '@epic-visualizations/charts';

export interface RewardsTop10GamesState {
    data: Datapoint[];
    loading: boolean;
    error?: string;
}

export const DEFAULT_STATE = fromJS({
    data: [],
    loading: false,
    error: undefined
});

export const rewardsTop10GamesReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {data, silent = false, error} = action.payload || {};

    switch (action.type) {
        case rewardsTop10GamesActions.TYPES.GET_REWARDS_TOP_10_GAMES: {
            return state.merge({
                error: undefined,
                loading: !silent
            });
        }

        case rewardsTop10GamesActions.TYPES.GET_REWARDS_TOP_10_GAMES_COMPLETE: {
            return state.merge({
                data,
                loading: false,
                error
            });
        }

        case rewardsTop10GamesActions.TYPES.GET_REWARDS_TOP_10_GAMES_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('rewardsTop10Games', rewardsTop10GamesReducer);
